import { State } from "./State";
export class QuestionOption {
    constructor(id, text, unLock, restrict, isNA) {
        this.id = id;
        this.text = new State(text);
        this.unLock = new State(unLock);
        this.restrict = new State(restrict);
        this.isNA = new State(isNA);
    }
    toJSON() {
        return {
            id: this.id,
            text: this.text.value,
            unLock: this.unLock.value,
            restrict: this.restrict.value,
            isNA: this.isNA.value,
        };
    }
}
